<template>
  <div class="super-tree" ref="SuperTree">
    <template v-if="useScene === 'configure'">
      <div class="super-tree--configure">
        <ConfigureHeader
          title="数据管理"
          :value="treeData"
          @on-change="onTreeChanged"
        ></ConfigureHeader>
        <SelectTree :value="treeData" @on-change="onTreeChanged"></SelectTree>
      </div>
    </template>
    <template v-else-if="useScene === 'cascader'">
      <Dropdown
        trigger="click"
        transfer
        transfer-class-name="super-tree-dropdown"
      >
        <SuperTreePreview
          v-model="treeData"
          @on-change="onSelectedChanged"
        ></SuperTreePreview>
        <template #list>
          <SuperTreeCascader
            ref="SuperTreeCascader"
            v-model="treeData"
            :options="cascaderOptions"
            @on-change="onSelectedChanged"
          ></SuperTreeCascader>
        </template>
      </Dropdown>
    </template>
  </div>
</template>

<script>
import ConfigureHeader from "./tree-configure/Header.vue";
import SuperTreePreview from "./cascader/Preview.vue";
import SelectTree from "./tree-configure/Tree.vue";
import SuperTreeCascader from "./cascader/Cascader.vue";
import { findNodeFromTree } from "@qingjin/jsuper";
export default {
  name: "SuperTree",
  components: {
    ConfigureHeader,
    SuperTreePreview,
    SelectTree,
    SuperTreeCascader,
  },
  props: {
    // 使用场景, configure|cascader
    useScene: {
      type: String,
      default: "cascader",
    },
    value: Array,
    cascaderOptions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      treeData: [],
    };
  },
  watch: {
    value: {
      handler() {
        if (this.useScene === "cascader" && this.value.length > 0) {
          this.treeData = this.value.map((item) => {
            const target = findNodeFromTree(
              ["value", item],
              this.cascaderOptions
            );
            return {
              value: item,
              label: target && target.label,
              checked: true,
            };
          });
        } else {
          this.treeData = JSON.parse(JSON.stringify(this.value));
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.useScene === "cascader")
      this.$refs.SuperTreeCascader.$el.style.width = `${this.$refs.SuperTree.offsetWidth}px`;
  },
  methods: {
    onSelectedChanged(selected) {
      if (this.useScene === "cascader") {
        selected = selected.map((item) => item.value);
      }
      this.$emit("input", selected);
      this.$emit("on-change", selected);
    },
    onTreeChanged(value) {
      this.$emit("input", value);
      this.$emit("on-change", value);
    },
  },
};
</script>

<style lang="stylus" scoped>
.super-tree
  width 100%

  &--configure
    border 1px solid #ddd
    border-radius 4px
    overflow hidden

  >>>.ivu-dropdown
    width 100%
</style>
<style lang="stylus">
.super-tree-dropdown
  height 200px !important
  padding 0 !important
  overflow hidden !important
</style>
